// src/eventBus.ts
import mitt from "mitt";

type Events = {
  "client-logged-in": void;
  "admin-logged-in": void;
  "sidenav:updated": any;
};

export const eventBus = mitt<Events>();
